import Image from "next/image";
import IconSend from "@/app/(components)/generics/Icons/IconSend";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { FLOW_AVATAR_SIZE, FLOW_CONTACT_PHOTO, FLOW_MESSAGES } from "../ConceptFlow.logic";
import styles from "../ConceptFlow.module.css";
import ConceptFlowMessageBubble from "./ConceptFlowMessageBubble";

export default function ConceptFlowMessageCard() {
  const T = useT();

  return (
    <div
      className={`${styles.card} ${styles.messageCard} ${styles.anchorRight}`}
      aria-hidden="true"
    >
      <div className={styles.chatHeader}>
        <span className={styles.chatContact}>
          <Image
            className={styles.chatAvatar}
            src={FLOW_CONTACT_PHOTO}
            alt=""
            width={FLOW_AVATAR_SIZE}
            height={FLOW_AVATAR_SIZE}
            unoptimized
          />
          <span className={styles.chatIdentity}>
            <span className={styles.cardName}>{T(TKey.HOME_MEIDLY_FLOW_MESSAGE_TITLE)}</span>
            <span className={styles.chatStatus}>{T(TKey.HOME_MEIDLY_FLOW_MESSAGE_STATUS)}</span>
          </span>
        </span>
        <span className={styles.capturedTag}>{T(TKey.HOME_MEIDLY_FLOW_CAPTURED_BY)}</span>
      </div>
      <div className={styles.chatThread}>
        {FLOW_MESSAGES.map((message) => (
          <ConceptFlowMessageBubble message={message} key={message.textKey} />
        ))}
      </div>
      <div className={styles.chatInput}>
        <span className={styles.chatPlaceholder}>
          {T(TKey.HOME_MEIDLY_FLOW_MESSAGE_PLACEHOLDER)}
        </span>
        <span className={styles.chatSend}>
          <IconSend />
        </span>
      </div>
    </div>
  );
}
